import automationStackImage from '../assets/automation-stack-case-study.svg';
import paymentGatewayImage from '../assets/crypto-payment-gateway.svg';
import maticOracleImage from '../assets/matic-oracle-case-study.svg';

import cisDappLogo from '../assets/cis-dapp-logo.png';

export const CASE_STUDIES = [
  {
    id: 0,
    title: 'Automation Stack',
    subtitle: 'End-to-End Pipeline Architecture',
    description: 'A full automation pipeline built for a business operator — connecting CRM, content publishing, lead capture, and reporting into one coherent system. No manual steps. No dropped handoffs. Runs 24/7.',
    category: 'Automation',
    image: automationStackImage,
    imageFit: 'contain',
    technologies: ['Claude MCP', 'Ottokit', 'LinkedIn API', 'Telegram Bot', 'Claude API'],
    keyFeatures: [
      'Lead capture → CRM → nurture sequence, fully automated',
      'Content pipeline publishing to LinkedIn and Telegram on schedule',
      'Reporting dashboard aggregating pipeline metrics'
    ],
    challenge: 'Client was managing 6 disconnected tools manually, losing leads and burning time on repetitive tasks.',
    solution: 'Mapped the full workflow, identified 4 automation nodes, built and connected them in n8n with fallback alerts and logging.',
    results: [
      '80% reduction in manual ops time',
      'Zero missed handoffs since deployment',
      'Full pipeline running 24/7 without intervention'
    ],
    docsUrl: null,
    liveUrl: null,
    demoUrl: 'https://calendly.com/quanturama',
    demoLabel: 'Schedule a Demo',
    tags: ['Automation', 'Claude MCP', 'Ottokit', 'CRM', 'Content Pipeline']
  },
  {
    id: 1,
    title: 'Blockchain Payment Infrastructure',
    subtitle: 'On-Chain Payment Gateway for Enterprise',
    description: 'A production-grade crypto payment gateway enabling businesses to accept on-chain payments across multiple networks — with automatic settlement, webhook notifications, and a merchant dashboard.',
    category: 'Web3 Infrastructure',
    image: paymentGatewayImage,
    imageFit: 'contain',
    technologies: ['Solidity', 'Polygon', 'Node.js', 'React', 'ethers.js'],
    keyFeatures: [
      'Multi-chain payment acceptance (Polygon, BSC)',
      'Automatic settlement to merchant wallet',
      'Webhook system for order confirmation',
      'Merchant dashboard with transaction history',
      'Token and stablecoin support'
    ],
    challenge: 'A business operator needed to accept crypto payments without relying on third-party processors — full custody, no fees, no intermediaries.',
    solution: 'Built a self-hosted payment infrastructure: smart contract for payment routing, backend for event listening and webhook dispatch, and a React merchant dashboard.',
    results: [
      'Fully self-custodied payment flow',
      'Sub-30s confirmation to merchant webhook',
      'Zero third-party processor dependency',
      'Live on Polygon mainnet'
    ],
    docsUrl: null,
    liveUrl: null,
    contactUrl: '/contact',
    contactLabel: 'Build This for Me',
    tags: ['Web3', 'Payments', 'Solidity', 'Polygon', 'Infrastructure']
  },
  {
    id: 3,
    title: 'CIS-Dapp',
    subtitle: 'Partner Build — Digital Foundation',
    description: 'Built the structure, branding, and digital identity for CIS — a technology services partner. Architecture, documentation, and service positioning delivered from scratch.',
    category: 'Partner Build',
    image: cisDappLogo,
    imageFit: 'contain',
    technologies: ['React', 'Web3', 'n8n', 'Cloud Infrastructure', 'Gitbook'],
    keyFeatures: [
      'Brand identity and visual system',
      'Web infrastructure and hosting architecture',
      'Service documentation (Gitbook)',
      'Automation pipeline setup',
      'Digital presence from zero'
    ],
    challenge: 'Launch a credible digital services brand with no existing infrastructure — identity, positioning, web presence, and documentation all needed from scratch.',
    solution: 'Delivered the full digital foundation: brand, site architecture, service framing, and documentation system. CIS operates the platform; Quanturama built it.',
    results: [
      'Full brand identity shipped',
      'Web infrastructure live',
      'Documentation system in place',
      'Active partner — referral pipeline open'
    ],
    docsUrl: 'https://cis-dapp.gitbook.io/cis-documentation',
    liveUrl: 'https://cis-dapp.com',
    tags: ['Partner', 'Branding', 'Web Infrastructure', 'Automation']
  },
  {
    id: 4,
    title: 'MATIC Oracle',
    subtitle: 'On-Chain Prediction Game',
    description: 'A fully on-chain BTC price prediction game built on Polygon. Players connect their wallet, predict price direction, and earn MATIC rewards. Real-time Chainlink oracle feed, on-chain scoring, leaderboard, and game state — no backend.',
    category: 'Web3 Game',
    image: maticOracleImage,
    imageFit: 'contain',
    technologies: ['Polygon', 'Solidity', 'Chainlink', 'ethers.js', 'React'],
    keyFeatures: [
      'Fully on-chain game rounds and reward distribution',
      'Real-time BTC price feed via Chainlink oracle',
      'SIWE wallet authentication — no accounts, no custody',
      'On-chain leaderboard and game state',
      'Sub-2s round resolution'
    ],
    challenge: 'Build a provably fair prediction game with zero backend dependency — all logic, state, and rewards handled entirely on-chain.',
    solution: 'Smart contract handles game rounds, oracle price feeds via Chainlink, reward distribution, and leaderboard state. Frontend connects via SIWE, reads chain state directly.',
    results: [
      'Fully on-chain — no server, no custody',
      'Live on Polygon mainnet',
      'Sub-2s round resolution via Chainlink feed'
    ],
    docsUrl: null,
    liveUrl: '/matic-oracle-demo.html',
    liveLabel: 'View Demo',
    tags: ['Web3', 'Game', 'Polygon', 'Chainlink', 'Solidity']
  }
];

export const CASE_STUDY_CONFIG = {
  sectionTitle: 'Case Studies',
  sectionSubtitle: 'How the systems were built.',
  viewAllText: 'View All Documentation'
};
